export default {
  token: (state) => state.token,
  authenticated: (state) => state.authenticated,
  location: (state) => state.location,
  user: (state) => state.user,
  user_role: (state) => state.user_role,
  impersonate: (state) => state.impersonate,
};
